import axios, { AxiosError } from 'axios';
import { SELF_SERVICE_API_URL } from 'config';
import type { SelfServiceAPI } from 'types';
import handleServiceError from '../utils/handleServiceError';

interface Data extends SelfServiceAPI.CreateDateAmendmentRequest.Request {
  bookingId: string;
}

interface Options {
  skipUnauthenticatedRedirection?: boolean;
  retry?: boolean;
}

const createDateAmendmentRequest = async (
  data: Data,
  options: Options = {},
): Promise<SelfServiceAPI.CreateDateAmendmentRequest.Response> => {
  const { bookingId, ...body } = data;
  try {
    const { data } = await axios.post<SelfServiceAPI.CreateDateAmendmentRequest.Response>(
      `${SELF_SERVICE_API_URL}/bookings/${bookingId}/date-amendment-request`,
      body,
      {
        withCredentials: true,
      },
    );

    return data;
  } catch (error) {
    if (options.retry !== false) {
      const status = error instanceof AxiosError && error.response?.status;

      if (status === 500) {
        return await createDateAmendmentRequest(data, { ...options, retry: false });
      }
    }

    handleServiceError(error, {
      operationName: `POST /bookings/${bookingId}/date-amendment-request`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default createDateAmendmentRequest;
